import React from "react"
import type { ChakraProps } from "@chakra-ui/react"
import { Text, Box } from "@chakra-ui/react"
import { colors } from "lib/theme"

type Props = ChakraProps & {
  footNotes: string[]
}

export const Footnotes: React.FC<Props> = ({ footNotes, ...chakraProps }) => {
  return (
    <Box width={{ base: "100%", lg: "65%" }} {...chakraProps}>
      {footNotes?.length &&
        footNotes.map((footNote, index) => (
          <Box key={footNote}>
            <Text color={colors.contentTertiary} variant="bookM1" as="span">
              <Text top="-0.25em" as="sup" color={colors.contentTertiary}>
                {index + 1}
              </Text>
              {` ${footNote}`}
            </Text>
          </Box>
        ))}
    </Box>
  )
}
